import React, { useContext, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import { isAdminUser } from "../utils/roleUtils";
import { getUiChildren } from "../utils/uiConfig";
import { getUiIcon } from "../utils/uiIcons";
import "./SmartToolsHome.css";

function AmazonManagerHome() {
  const navigate = useNavigate();
  const { user, uiConfig } = useContext(AuthContext);
  const isAdmin = isAdminUser(user);

  const tools = useMemo(
    () =>
      getUiChildren(uiConfig, "amazon-manager-home", { isAdmin }).map((item) => ({
        ...item,
        Icon: getUiIcon(item.icon),
      })),
    [isAdmin, uiConfig]
  );

  return (
    <div className="tools-wrapper">
      <div className="tools-header-section">
        <button className="back-pill" onClick={() => navigate("/tools")}>
          ← Smart Tools
        </button>
        <h2 className="tools-title-main">Amazon Manager</h2>
      </div>

      <div className="tools-grid-container">
        {tools.map((tool) => {
          const Icon = tool.Icon;
          return (
            <div
              key={tool.id}
              className="tool-card-premium"
              onClick={() => navigate(tool.route)}
              style={{ "--accent-color": tool.accentColor || "#ff9900" }}
            >
              <div className="tool-icon-circle">
                <Icon />
              </div>
              <div className="tool-info">
                <h3 className="tool-name">{tool.label}</h3>
                <p className="tool-desc">{tool.description}</p>
              </div>
              <div className="tool-arrow">-&gt;</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AmazonManagerHome;
